import { render } from "./weiTag.vue?vue&type=template&id=0b1a4bbd"
import script from "./weiTag.vue?vue&type=script&lang=js"
export * from "./weiTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__